import logo from '@/assets/images/logo.png'
import { useData } from '@/hooks/useLocale'

/** The logo, whitened for the dark header and footer. */
export default function Logo({ className = '' }) {
  const { SITE_NAME } = useData()
  return (
    <img
      src={logo}
      alt={SITE_NAME}
      className={`block brightness-0 invert ${className}`}
    />
  )
}
